import useGetRejectReasonTableColumns from './useGetRejectReasonTableColumns'

export default useGetRejectReasonTableColumns
